// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.word-column {
  margin-left: 1vw;
  margin-right: 1vw;
  margin-top: 5px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  border: dotted;
  border-color: rgb(126, 133, 125);
  border-radius: 3px;
  max-width: 30vw;
  /* background-color: rgba(247, 232, 186, 0.397); */
}

.word-column.empty {
  border:none;
}`, "",{"version":3,"sources":["webpack://./src/Components/Games/Newsie/UploadContentNewsie/NewsiePreview/WordColumn/WordColumn.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,WAAW;AACb","sourcesContent":[".word-column {\n  margin-left: 1vw;\n  margin-right: 1vw;\n  margin-top: 5px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: center;\n  border: dotted;\n  border-color: rgb(126, 133, 125);\n  border-radius: 3px;\n  max-width: 30vw;\n  /* background-color: rgba(247, 232, 186, 0.397); */\n}\n\n.word-column.empty {\n  border:none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
